import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import BookingCalendar from '../../components/feature/BookingCalendar';

export default function ConsulenzaPage() {
  const [showBooking, setShowBooking] = useState(false);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-video-chat-fill text-3xl text-white"></i>
              </div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Consulenza gratuita in Videoconferenza
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
                Ricevi una consulenza personalizzata per valutare le tue esigenze specifiche e scegliere il contratto di locazione più adatto per il tuo immobile.
              </p>
              <Button size="lg" className="cursor-pointer" onClick={() => setShowBooking(true)}>
                Prenota Consulenza Gratuita
              </Button>
            </div>
          </div>
        </section>

        {/* Dettagli Servizio */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Come Funziona la Consulenza
                </h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-blue-600 font-bold">1</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Prenotazione Online</h3>
                      <p className="text-gray-600">Scegli data e orario che preferisci dal nostro calendario disponibile</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-blue-600 font-bold">2</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Videochiamata Professionale</h3>
                      <p className="text-gray-600">Incontro di 15 minuti con un agente immobiliare esperto tramite videoconferenza</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-blue-600 font-bold">3</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Analisi Personalizzata</h3>
                      <p className="text-gray-600">L'agente immobiliare, in base alle informazioni ricevute dal cliente , consiglierà il contratto più adatto e conveniente </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-blue-600 font-bold">4</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Piano d'Azione</h3>
                      <p className="text-gray-600">Se hai gradito la consulenza gratuita iniziale, potrai prenotare per la preparazione del contratto personalizzato con il nostro agente immobiliare</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-cover bg-center rounded-xl h-96" style={{
                backgroundImage: `url('/images/consulenza-detail.jpg')`
              }}></div>
            </div>
          </div>
        </section>

        {/* Cosa Include */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Cosa Include la Consulenza
              </h2>
              <p className="text-xl text-gray-600">
                Un servizio completo per guidarti in ogni aspetto del contratto di locazione
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-search-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Analisi Situazione</h3>
                <p className="text-gray-600">Valuteremo assieme la tipologia immobile per identificare le migliori opzioni disponibili</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-file-list-3-line text-2xl text-purple-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Scelta Contratto</h3>
                <p className="text-gray-600">Ti aiutiamo a scegliere il tipo di contratto più vantaggioso per le tue esigenze specifiche</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-question-answer-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Domande e Risposte</h3>
                <p className="text-gray-600">Rispondiamo a tutti i tuoi dubbi e domande sui contratti di locazione e procedure</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-calculator-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Calcolo Costi</h3>
                <p className="text-gray-600">Stima di tutti i costi associati al contratto, tasse e spese di registrazione</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-roadmap-line text-2xl text-indigo-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Piano Personalizzato</h3>
                <p className="text-gray-600">Ricevi un piano d'azione dettagliato con tutti i passi successivi da seguire</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-blue-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Prenota la Tua Consulenza Gratuita
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              Ricevi consigli professionali personalizzati per il tuo contratto di locazione
            </p>
            <Button variant="secondary" size="lg" className="cursor-pointer" onClick={() => setShowBooking(true)}>
              Prenota Ora
            </Button>
          </div>
        </section>
      </main>
      <Footer />
      
      <BookingCalendar isOpen={showBooking} onClose={() => setShowBooking(false)} />
    </div>
  );
}